import GetRequest from "../../service/GetRequest";

export const ProductService = {
    async getProductsData(categoryId,branchId) {
        try {
            const response = await GetRequest(`v1/inventory-service/view/products/${categoryId}?branchId=${branchId}`);

            if (!response || response.length === 0) {
                console.log("Empty response or undefined data for categories");
                return []; // Return an empty array if response is empty or undefined
            } else {
                return response; // Return the response array
            }
        } catch (error) {
            console.error("Error fetching product data:", error);
            return []; // Return an empty array in case of error
        }
    },

    async getProductsWithOrdersData(branchId) {
        try {
            const response = await GetRequest(`v1/inventory-service/view/order-details/items/branches/${branchId}`, true);

            if (!response || response.length === 0) {
                console.log("Empty response or undefined data for categories");
                return []; // Return an empty array if response is empty or undefined
            } else {
                return response; // Return the response array
            }
        } catch (error) {
            console.error("Error fetching product data:", error);
            return []; // Return an empty array in case of error
        }
    },

    // getProductsWithOrdersData() {
    //     return [
    //         {
    //             id: '1000',
    //             code: 'f230fh0g3',
    //             name: 'Bamboo Watch',
    //             description: 'Product Description',
    //             image: 'bamboo-watch.jpg',
    //             price: 65,
    //             category: 'Accessories',
    //             branch:12,
    //             quantity: 24,
    //             inventoryStatus: 'INSTOCK',
    //             rating: 5,
    //             orders: [
    //                 {
    //                     id: '1000-0',
    //                     productCode: 'f230fh0g3',
    //                     date: '2020-09-13',
    //                     amount: 65,
    //                     quantity: 1,
    //                     customer: 'David James',
    //                     status: 'PENDING'
    //                 },
    //                 {
    //                     id: '1000-1',
    //                     productCode: 'f230fh0g3',
    //                     date: '2020-05-14',
    //                     amount: 130,
    //                     quantity: 2,
    //                     customer: 'Leon Rodrigues',
    //                     status: 'DELIVERED'
    //                 },
    //                 {
    //                     id: '1000-2',
    //                     productCode: 'f230fh0g3',
    //                     date: '2019-01-04',
    //                     amount: 65,
    //                     quantity: 1,
    //                     customer: 'Juan Alejandro',
    //                     status: 'RETURNED'
    //                 },
    //                 {
    //                     id: '1000-3',
    //                     productCode: 'f230fh0g3',
    //                     date: '2020-09-13',
    //                     amount: 195,
    //                     quantity: 3,
    //                     customer: 'Claire Morrow',
    //                     status: 'CANCELLED'
    //                 }
    //             ]
    //         },
    //         // More product data...
    //     ];
    // },

    getProductsMini() {
        return Promise.resolve(this.getProductsData().slice(0, 5));
    },

    getProductsSmall() {
        return Promise.resolve(this.getProductsData().slice(0, 10));
    },

    getProducts(categoryId,branchId) {
        return Promise.resolve(this.getProductsData(categoryId,branchId));
    },

    getProductsWithOrdersSmall(branchId) {
        return Promise.resolve(this.getProductsWithOrdersData(branchId));
    },

    getProductsWithOrders() {
        return Promise.resolve(this.getProductsWithOrdersData());
    }
};
